<template>
    <section>
        <div class="page-wrap">
            <div class="container product">
                <div class="box-content">
                    <h2>Customize Your Order</h2>
                    <div>
                        <p>
                            Enter an inscription below to customize your paver.
                            Each line allows for {{ info.max_chars }} characters per line.
                            View our <a class="text-danger underline pointer"
                                v-on:click="showInscriptionGuidelines()"
                            >inscription policy</a> for more information.
                        </p>
                    </div>
                    <div class="row">
                        <div class="col-md-7">
                            <div class="prod-container">
                                <img class="prod-img" v-bind:src="getProductImage(logo)"/>
                                <div class="prod-replica">
                                    <div class="prod-replica-table">
                                        <div class="prod-replica-table-td" v-bind:class="product.classes">
                                            <p v-for="n in product.max_lines">{{ lines[n-1] }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <h3 v-html="product.description"></h3>
                            <h4>$&nbsp;{{ product.price }}</h4>
                            <hr/>
                            <h3>Brick Inscription:</h3>
                            <div class="brick-text-form">
                                <div v-for="n in product.max_lines" class="form-group row no-gutter">
                                    <div class="col-md-2">
                                        <label v-bind:for="'l-' + n">Line {{ n }}:</label>
                                    </div>
                                    <div class="col-md-10">
                                        <input class="form-control"
                                            v-bind:line-id="'l-' + n"
                                            v-on:keydown="withAnyKeyDown($event)"
                                            v-on:keyup="withAnyKeyUp($event)"
                                            v-on:input="withInput($event)"
                                            v-bind:id="'l-' + n"
                                            v-bind:value="lines[n-1]"
                                            v-bind:maxlength="product.max_characters"
                                            v-bind:size="product.max_characters"
                                        />
                                    </div>
                                </div>
                            </div>
                            <p>Need inspiration?
                                <a class="text-danger pointer" v-on:click="showInscriptionExamples()">Click here</a>
                                for inscription examples.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <p>
                                * This image is for representation only and is not an exact reflection of your completed brick (please refer to About page).
                                All materials subject to change based on final architectural design.
                            </p>
                        </div>
                    </div>
                    <preferred-logo v-if="isMultiLogoAllowed"
                        ref="preflog"
                        v-bind:options="product.options || {}"
                        v-bind:logo="logo"
                        on-logo-change="onProductLogoChange"
                    ></preferred-logo>
                    <template v-if="item_id > 0">
                        <hr/>
                        <h3>ADDITIONAL ITEMS</h3>
                        <p>
                            Bring your Prosper ISD pride home with keepsake items that proudly showcase your personalized message.
                            These special edition items are perfect gifts for graduations, holidays, birthdays and more!
                            Replica bricks are made with the same material and message as your installed Stadium Brick.
                        </p>
                        <br/>
                        <div class="row">
                            <div class="col-sm-4 text-center" v-for="(child, childIndex) in baseProductChildren">
                                <div class="img-box">
                                    <div v-bind:class="{
                                        'img-wrap': !is4x8(child.item_image_blank || ''),
                                        'img-wrap-4x8': is4x8(child.item_image_blank || '')
                                    }">
                                        <div class="prod-container">
                                            <img class="prod-img" v-bind:src="getChildImage(child, logo)"/>
                                            <div v-if="(child.item_type === 2 || child.item_type === 4)" class="prod-replica">
                                                <div class="prod-replica-table">
                                                    <div class="prod-replica-table-td" v-bind:class="child.classes">
                                                        <p v-for="n in product.max_lines">{{ lines[n-1] }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <p class="product-title text-left">
                                    <span v-html="child.description"></span>
                                </p>
                                <div class="row wrap-count">
                                    <div class="col-xs-6 text-left">${{child.price}}</div>
                                    <div class="col-xs-6 text-right">
                                        <div class="amount no-select">
                                            <span v-on:click="sub1(child.item_id)" class="pointer">-</span>
                                            <span>{{ qtys[child.item_id] }}</span>
                                            <span v-on:click="add1(child.item_id)" class="pointer">+</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="btn-wrap">
                                <a class="btn btn-danger btn-lg pull-right"
                                    v-bind:disabled="item_id == 0"
                                    v-on:click="addToCart"
                                >Add to cart</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script type="text/jsx">
    import Vue from 'vue'
    import { Event } from '../../../../../assets/js/components/frontend/event.vue'
    import store from '../../store'
    import CampaignConfigurationMixin from '../../../../../assets/js/components/frontend/mixin/campaign-configuration.vue'
    import InscriptionEditMixin from '../../../../../assets/js/components/frontend/mixin/inscription-edit.vue'
    import InscriptionHandlingMixin from '../mixin/inscription-handling.vue'
    import ProductHandlingMixin from '../mixin/product-handling.vue'
    import PreferredLogo from '../elements/preferred-logo.vue'
    export default {
        name: 'product',
        mixins: [
            CampaignConfigurationMixin,
            InscriptionEditMixin,
            InscriptionHandlingMixin,
            ProductHandlingMixin
        ],
        components: {
            'preferred-logo': PreferredLogo
        },
        data: function () {
            return this.getDefaultData();
        },
        props: {
            isLowerCaseAllowed: { // to override default value in InscriptionEditMixin
                type: String,
                default: () => 'no'
            },
            info: {
                type: Object, // can be modified by child component
                required: false,
                default: function () {
                    return {
                        max_chars: 16 // minimal known value as default
                    };
                }
            }
        },
        beforeRouteEnter(to, from, next) {
            let productId = to.params.id || '';
            if (productId in store.getters.products) {
                next();
            } else {
                next({name: 'Shop'});
            }
        },
        created: function () {
            Event.$on('onProductLocationChange', this.onLocationChange);
            Event.$on('onProductLogoChange', this.onLogoChange);
        },
        beforeDestroy: function () {
            Event.$off('onProductLocationChange', this.onLocationChange);
            Event.$off('onProductLogoChange', this.onLogoChange);
        },
        methods: {
            getDefaultData: function () {
                return {
                    item_id: 0, // zero for a GC
                    location: '', // preferred
                    logo: '', // preferred
                    default_max_characters: 16, // minimal default value
                    qtys: {}, // item_id => qty
                    lines: {
                        // index: text
                    }
                }
            },
            showInscriptionGuidelines: function () {
                Event.$emit(
                    'inscriptionGuidelinesPopup',
                    { max_chars: this.product.max_characters || this.default_max_characters }
                );
            },
            showInscriptionExamples: function () {
                Event.$emit('inscriptionExamplesPopup');
            },
            showPaverLocations: function () {
                Event.$emit('paverLocationsPopup');
            },
            addToCart: function () {
                this.validateProductProperties().then(() => {
                    this.$store.commit('addItemToCart', {
                        item_id: this.item_id > 0 ? this.item_id : +this.$route.params.id,
                        temp_id: +new Date(),
                        options: {
                            location: this.location,
                            logo: this.logo
                        },
                        gc: false,
                        lines: this.lines,
                        children: this.qtys
                    });
                    this.$router.push({ path: '/cart'});
                }).catch(() => {
                    console.log('Adding to Cart failed due to validation errors!');
                });
            },
            onProductChange: function (id) {
                if (id in this.products) {
                    this.item_id = id;
                }
            },
            onLocationChange: function (newLocation) {
                this.location = newLocation;
            },
            onLogoChange: function (newLogo) {
                this.logo = newLogo;
            },
            add1: function (itemId) {
                var newValue = (itemId in this.qtys) ? this.qtys[itemId] : 0;
                newValue++;
                Vue.set(this.qtys, itemId, newValue);
            },
            sub1: function (itemId) {
                var newValue = (itemId in this.qtys) ? this.qtys[itemId] : 0;
                if (newValue > 0) {
                    newValue--;
                }
                Vue.set(this.qtys, itemId, newValue);
            },
            getProductImage: function (logoId) {
                var res = '';
                if (logoId in this.logosList) {
                    res = this.baseImagePath + this.logosList[logoId].item_image_blank;
                    return res;
                }
                res = this.baseImagePath + this.product.item_image_blank;
                return res;
            },
            getChildImage: function (child, logoId) {
                var res = '';
                if (logoId in this.logosList) {
                    if ((child.item_type === 2 || child.item_type === 4)) {
                        // logo-related item detected
                        if ('item_number' in this.logosList[logoId]) {
                            res = this.baseImagePath + '8x8' +
                            'blank' + 'logorep' +
                            this.logosList[logoId].item_number + '.png';
                            return res;
                        }
                    }
                }
                res = this.baseImagePath + child.item_image_blank;
                return res;
            }
        },
        computed: {
            campaign: function () {
                return this.$store.state.campaign
            },
            products: function () {
                return this.$store.getters.products
            },
            product: function () {
                var productId = this.$route.params.id;
                if (productId in this.$store.getters.products) {
                    this.item_id = productId;
                    return this.$store.getters.products[this.$route.params.id];
                }
                return {};
            },
            baseProductChildren: function () {
                if (this.item_id in this.products) {
                    var qtys = {};
                    var children = this.products[this.item_id]['children'];
                    for (var key in children) {
                        if ('item_id' in children[key]) {
                            qtys[children[key]['item_id']] = 0;
                        }
                    }
                    this.qtys = Object.assign({}, qtys);
                    return this.products[this.item_id]['children'];
                } else {
                    return [];
                }
            },
            baseImagePath: function () {
                return 'images/catalog/' + this.campaign.short_url + '/';
            },
            logosList: function () {
                var res = {};
                if (this.isMultiLogoAllowed) {
                    if ("options" in this.product && this.product.options) {
                        if ("logo" in this.product.options && this.product.options.logo) {
                            res = this.product.options.logo;
                        }
                    }
                }
                return res;
            }
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// Product.vue?d0b0cc8a